import { render } from "./EditMenu.vue?vue&type=template&id=726abd5c"
import script from "./EditMenu.vue?vue&type=script&lang=js"
export * from "./EditMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__